import { Slider as MuiSlider } from "@mui/material";
import React from "react";

export interface SliderProps {
  ariaLabel?: string;
  ariaLabelledby?: string;
  value: number | string | undefined;
  defaultValue?: number;
  min?: number;
  max?: number;
  onValueChange: (value: number) => void;
}

const styles = {
  marginTop: "1rem",
};

const getMarks = (min: number, max: number) => {
  const marks = [];
  for (let i = min; i <= max; i++) {
    marks.push({ label: String(i), value: i });
  }
  return marks;
};

export const Slider: React.FC<SliderProps> = ({
  ariaLabelledby,
  value,
  defaultValue = 0,
  onValueChange,
  min = 0,
  max = 10,
}) => {
  const marks = getMarks(min, max);
  const formattedValue = Number(value) || defaultValue;

  return (
    <MuiSlider
      {...(ariaLabelledby && { "aria-labelledby": ariaLabelledby })}
      defaultValue={defaultValue}
      valueLabelDisplay="auto"
      step={1}
      marks={marks}
      min={min}
      max={max}
      value={formattedValue}
      onChange={(e, newValue: number | number[]) => {
        const parsedValue = Array.isArray(newValue) ? newValue[0] : newValue;
        onValueChange(parsedValue);
      }}
      sx={styles}
    />
  );
};
